module.exports = __webpack_public_path__ + "img/bg@2x.a8d9bd55.jpg";